import { getUserId } from '../../../../DefaultService';
import { IPaginationParams } from '../../../../types';
import { queryClient } from 'index';
import { IFaceRecognitionEventSimpleProps } from '../../types';

export const FACE_RECOGNITION_EVENT_CACHE_KEY = 'faceRecognitionEvent';

const USER_ID = getUserId();

export const useFaceRecognitionEventDataStreamCache = () => {
  return {
    getCacheData: (pagination: IPaginationParams): any[] | undefined =>
      queryClient.getQueryData<IFaceRecognitionEventSimpleProps[]>([
        `${FACE_RECOGNITION_EVENT_CACHE_KEY}${pagination.pageNumber}`,
        pagination,
        USER_ID,
      ]),
    setCacheData: (
      data: IFaceRecognitionEventSimpleProps[],
      pagination: IPaginationParams,
    ) =>
      queryClient.setQueryData(
        [
          `${FACE_RECOGNITION_EVENT_CACHE_KEY}${pagination.pageNumber}`,
          pagination,
          USER_ID,
        ],
        data,
      ),
    clearCacheData: () => {
      queryClient
        .getQueryCache()
        .getAll()
        .forEach(({ queryKey }) => {
          if (
            Array.isArray(queryKey) &&
            queryKey[0].startsWith(FACE_RECOGNITION_EVENT_CACHE_KEY) &&
            queryKey[2] == USER_ID
          ) {
            queryClient.removeQueries({ queryKey });
          }
        });
    },
  };
};
